const $ = jQuery.noConflict();
const pageSections = $('.acf-block[id], .block-hook').get().reverse();
const stickyNav = $('.sticky-nav');
const header = $('.main-header');

function scrollFunc(e) {
    e.preventDefault();
    const target = $($(this).attr('href'));
    let stickyHeight = header.outerHeight();

    if ( stickyNav.length ) {
        stickyHeight += stickyNav.outerHeight();
    }

    if ($(this).attr('href') === '#next' && $(this).parents('section, .block-hook').next().length > 0) {
        // Smooth Scroll to next section
        $('html, body').animate({
            scrollTop: $(this).parents('section, .block-hook').next().offset().top - stickyHeight,
        }, 600);
    } else if (target.length) {
        let offsetTop = target.offset().top
        const pt = parseInt(target.css('padding-top'), 10)
        
        if ( 0 === pt ) {
            if ( window.matchMedia('(max-width: 768px)') ) {
                offsetTop -= 30
            } else {
                offsetTop -= 60
            }
        }

        $('html, body').animate({
            scrollTop: offsetTop - stickyHeight,
        }, 600);
    }

    $('body').addClass('smooth-scrolling');
    setTimeout(() => {
        $('body').removeClass('smooth-scrolling');
    }, 600)
}

function setActiveNavElement(el) {
    if ( el !== undefined ) {
        const $links = stickyNav.find('a');

        let $currentLink = stickyNav.find(`a[href="#${el.id}"]`);
        let counter = 0;

        while ( ! $currentLink.length && counter < 50 && null !== el ) {
            el = el.previousSibling
            if ( null !== el ) {
                $currentLink = stickyNav.find(`a[href="#${el.id}"]`);
            }
            counter++;
        }

        $links.blur().parent().removeClass('active');
        $currentLink.parent().addClass('active');
    }
}

window.scrollPrevEl = null;
const markCurrentNavItem = () => {
    if (stickyNav.length > 0) {
        const navBottomOffset = header.offset().top + header.outerHeight() + stickyNav.outerHeight() + 1;

        const currentSection = pageSections.find((section) => {
            const el = $(section);
            const pt = parseInt(el.css('padding-top'), 10)
            let offsetTop = el.offset().top
            
            if ( 0 === pt ) {
                if ( window.matchMedia('(max-width: 768px)') ) {
                    offsetTop -= 30
                } else {
                    offsetTop -= 60
                }
            }

            return el.is(':visible') && navBottomOffset > offsetTop;
        });
        
        if (currentSection && !$('body').hasClass('smooth-scrolling') && currentSection !== window.scrollPrevEl) {
            setActiveNavElement(currentSection);
            window.scrollPrevEl = currentSection;
        }
    }
}

function smoothScroll() {
    $('a[href^="#"]:not([href="#"])').on('click', scrollFunc);
}
export { smoothScroll as default, markCurrentNavItem };
